export default __webpack_public_path__ + "static/media/statuts_apmf_2016.858ba248.pdf";